<template>
    <div class="screening-qr-dialog">
        <dialog-header class="screening-qr-dialog-header" v-model="headerTitle" @close="onDialogClose"></dialog-header>
        <div class="screening-qr-dialog-content">
            <vue-qr ref="qr" id="qrcode" class="screening-qr-dialog-content-qr" :logoSrc="imageUrl" :text="url"
                :size="200"></vue-qr>
            <div class="screening-qr-dialog-content-download" @click="downLoadQR('qr')">点击下载</div>
        </div>
    </div>
</template>
  
<script>
import dialogHeader from "@c/screening-questionnaire/screening-dialog/screening-dialog-header.vue";
import { computed } from "vue";
import vueQr from 'vue-qr';
export default {
    props: {
        value: String,
        qrURL: String,
        name: String,
        hospitalId: Number,
    },
    components: {
        dialogHeader,
        vueQr,
    },
    data() {
        return {
            headerTitle: this.value,
            qrId: '',
            url: '',
            taskName: '',
        };
    },
    methods: {

        onDialogClose(value) {
            this.$emit('close', value);
        },
        downLoadQR() {
            const iconUrl = this.$refs.qr.$el.src
            const a = document.createElement('a')
            const event = new MouseEvent('click')
            a.download = this.taskName+'二维码.png'
            a.href = iconUrl
            a.dispatchEvent(event)
        },

    },
    computed: {
        imageUrl() {
            const 周口市妇幼保健院ID = 1744
            const 河南省儿童睡眠呼吸疾病早期筛查与精准诊疗工程研究中心 = 1853
            const 南宁市妇幼保健医院 = 252
            const list = [周口市妇幼保健院ID, 河南省儿童睡眠呼吸疾病早期筛查与精准诊疗工程研究中心, 南宁市妇幼保健医院] 
            if (list.includes(this.hospitalId)) {
                return ''
            }
            return require("@imgs/logo-bajie-small-28.png")
        }
    },
    watch: {
        qrURL(newVal) {
            this.url = newVal
        },
        name(newVal){
            this.taskName = newVal
        }
    },
    mounted() {
        this.url = this.qrURL
        console.log("qrrul",this.url);
        this.taskName = this.name
    },

}
</script>
   
<style lang="scss" scoped>
@import "@css/style.scss";

.screening-qr-dialog {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;

    &-header {
        width: 100%;
        height: rem(57);
    }

    &-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #325FAC;

        &-download {
            cursor: pointer;
        }
    }




}
</style>